import Router from 'vue-router'
import routes from './routes.js'

const router = new Router({
    mode: 'history',
    base: import.meta.env.BASE_URL,
    routes,
    scrollBehavior () {
        return {
            x: 0,
            y: 0
        }
    },
})

export default router
